import { AutogenModelOverdueEvent, AutogenRowOverdueEvent } from "./autogen/AutogenModelOverdueEvent";

export class ModelOverdueEvent extends AutogenModelOverdueEvent<RowOverdueEvent> {
	constructor() {
		super(RowOverdueEvent);
	}
}

export class RowOverdueEvent extends AutogenRowOverdueEvent {
}